
import { SkeletonFilters } from '../skeleton-filters';
import { SkeletonContent } from '../skeleton-content';

import './style.scss';

export interface IProps {
  label: string;
}

export function SkeletonResult({ label }: IProps) {

  return (
    <div className="skeleton-wrapper">
      <div className="skeleton-wrapper__wrapper">
        <div className="skeleton-wrapper__block-filters">
          <SkeletonFilters />
        </div>
        <div className="skeleton-wrapper__block-content">
          <SkeletonContent label={label} />
        </div>
      </div>
    </div>
  );
}
